import { Link } from 'react-router-dom';

import type { CourseExercise } from '../features/courses/courseApi';

const EXERCISE_TYPES: Record<string, { label: string; icon: string }> = {
  SHELL_CHALLENGE: { label: 'Shell challenge', icon: '$' },
  FILL_BLANK: { label: 'Fill in the blank', icon: '✎' },
  MULTIPLE_CHOICE: { label: 'Quiz', icon: '☑' },
  OUTPUT_MATCH: { label: 'Output match', icon: '↔' },
};

function ExerciseCard({ exercise }: { exercise: CourseExercise }) {
  const typeInfo = EXERCISE_TYPES[exercise.type] ?? { label: 'Exercise', icon: '•' };

  return (
    <Link
      to={`/exercise/${exercise.id}`}
      aria-label={`${exercise.title} - ${typeInfo.label}`}
      style={{
        display: 'grid',
        gap: '0.5rem',
        padding: '1rem',
        border: '1px solid var(--color-border-strong)',
        borderRadius: '0.75rem',
        color: 'inherit',
        textDecoration: 'none',
      }}
    >
      <span aria-hidden="true" style={{ fontSize: '1.5rem' }}>{typeInfo.icon}</span>
      <span style={{ fontWeight: 700 }}>{exercise.title}</span>
      <span
        style={{
          justifySelf: 'start',
          padding: '0.2rem 0.55rem',
          borderRadius: '999px',
          background: 'var(--color-bg-elevated)',
          border: '1px solid var(--color-border)',
          fontSize: '0.8rem',
        }}
      >
        {typeInfo.label}
      </span>
      <span>{exercise.points ?? 0} points</span>
    </Link>
  );
}

export default ExerciseCard;
